
export const getPermission = (state, res) => {
  state.permissions = res
}

export const permissionFormReset = (state) => {
  state.permission = {
    name: '',
    guard_name: 'api',
    group_id: null
  }
}

export const permissionForm = (state, val) => {
  state.permission = val
}


export const getListPermission = (state, val) => {
  state.permissionList = val
}

export const getRole = (state, res) => {
  state.roles = res
}

export const getRoleList = (state, res) => {
  state.roleList = res
}

export const roleFormReset = (state) => {
  state.role = {
    name: '',
    guard_name: 'api'
  }
}

export const roleForm = (state, val) => {
  state.role = val
}

export const getRolePermission = (state, val) => {
  state.permissionSelected = val
}
